import React from "react";
import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useState } from "react";
import ReactSelect from "react-select";
import { dropdownStyles } from "../../buy/buy";
import Client from "../../../utils/client";

function ReactTable({ data, columns }) {
  const [filtering, setFiltering] = useState("");
  const [market, setMarket] = useState("");
  const [product, setProduct] = useState("");
  const [sorting, setSorting] = useState([]);
  const markets = data.map((e) => e.market);
  let uniqe = [...new Set(markets)];
  const products = data.map((e) => e.product);
  let uniqeProducts = [...new Set(products)];

  const table = useReactTable({
    data:
      market && !product
        ? market
        : product && !market
        ? product
        : product && market
        ? data?.filter(
            (e) =>
              e.product === product[1]?.product &&
              e.market === market[1]?.market
          )
        : data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting: sorting,
    },
    onSortingChange: setSorting,
  });

  return (
    <>
      <div className="mx-2 lg:h-[22rem] ">
        <div className="justify-end flex my-3 mb-6 gap-3 items-center">
          <div
            className="font-bold text-red-700  rounded-full border-red-700 border px-2 "
            onClick={() => (setMarket(""), setProduct(""))}
          >
            X
          </div>
          <ReactSelect
            onChange={(e) => {
              Client.get("/price/product/" + e.value).then((res) =>
                setProduct(res.data)
              );
            }}
            options={uniqeProducts.map((e) => {
              return { label: e, value: e };
            })}
            hideSelectedOptions={false}
            styles={dropdownStyles}
            closeMenuOnSelect={true}
            // value={product}
            isRtl
            placeholder="المنتج"
            className="w-[15rem]"
          />
          <ReactSelect
            onChange={(e) => {
              Client.get("/price/market/" + e.value).then((res) =>
                setMarket(res.data)
              );
            }}
            options={uniqe.map((e) => {
              return { label: e, value: e };
            })}
            hideSelectedOptions={false}
            styles={dropdownStyles}
            closeMenuOnSelect={true}
            isRtl
            // value={market}
            placeholder="السوق"
            className="w-[15rem]"
          />
        </div>
        <div
          dir="rtl"
          className={`overflow-x-scroll lg:overflow-hidden  mx-auto w-full lg:w-[70rem]   ${
            data.length < 1
              ? "bg-gray-50 animate-pulse h-[20rem] lg:h-[80%] "
              : ""
          } `}
        >
          <table
            dir="ltr"
            className={`  mx-auto w-full  lg:w-[70rem]
          `}
          >
            <thead className="">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th
                      key={header.id}
                      onClick={header.column.getToggleSortingHandler()}
                    >
                      {header.isPlaceholder ? null : (
                        <div
                          className={`  mb-2 px-1  hover:cursor-pointer hover:bg-green-100 `}
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                          {
                            { asc: "   ↑", desc: "   ↓" }[
                              header.column.getIsSorted() ?? null
                            ]
                          }
                        </div>
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id} className="odd:bg-gray-100">
                  {row.getVisibleCells().map((cell) => (
                    <td
                      key={cell.id}
                      className={`px-1  text-center  ${
                        cell.column.columnDef.accessorKey === "product"
                          ? "w-[15rem]"
                          : cell.column.columnDef.accessorKey === "unit"
                          ? "w-[10rem]"
                          : "w-[6rem]"
                      }

                  `}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className=" text-right mt-3 relative top-0 right-2 ">
        <div className="flex gap-2 justify-end">
          <button
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            className="text-xs font-bold text-white bg-secondary rounded-md px-2"
          >
            النهاية
          </button>
          <div className="flex gap-2 text-white">
            <button
              disabled={!table.getCanNextPage()}
              onClick={() => table.nextPage()}
              className="bg-secondary rounded-full px-1 disabled:bg-gray-200"
            >
              &larr;
            </button>
            <button
              disabled={!table.getCanPreviousPage()}
              onClick={() => table.previousPage()}
              className="bg-secondary rounded-full px-1 disabled:bg-gray-200"
            >
              &rarr;
            </button>
          </div>
          <button
            onClick={() => table.setPageIndex(0)}
            className="text-xs font-bold text-white bg-secondary rounded-md px-2"
          >
            البداية
          </button>
        </div>
        <div className="mt-2 flex flex-row-reverse gap-2 justify-start">
          عدد الصفحات
          <strong>{table.getPageCount().toLocaleString("en-US")}</strong>
        </div>
      </div>
    </>
  );
}

export default ReactTable;
